<template>
  <v-container>
    <v-card class="orange lighten-5" elevation="3">
      <v-card-title class="wihte--text orange">
        <h1>{{ product.name }} fra {{ vendor.name }}</h1>
      </v-card-title>

      <v-card-text>
        <p>{{ product.name }}</p>

        <p>Kr {{ product.price }},-</p>

        <v-img v-if="product.image" :src="product.image"></v-img>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import backend from "@/backend";

export default {
  name: "VendorProductDetail",

  props: {
    vendorId: {
      type: String,
      required: true,
    },
    productId: {
      type: String,
      required: true,
    },
  },

  data: function () {
    return {
      vendor: {},
      product: {},
    };
  },

  async created() {
    this.vendor = await backend.get(`vendors/${this.vendorId}/`);
    this.product = await backend.get(`products/${this.productId}/`, {
      vendor: this.vendor.id,
    });
  },
};
</script>
